import type { Point } from './types';

export const clamp = (value: number, min: number, max: number): number =>
  Math.max(min, Math.min(Math.max(min, max), value));
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
export const randomBetween = (min: number, max: number): number => lerp(min, max, Math.random());
export const easeOutCubic = (t: number): number => 1 - (1 - t) ** 3;

export function arcPosition(from: Point, to: Point, progress: number, height: number): Point {
  const t = clamp(progress, 0, 1);
  return { x: lerp(from.x, to.x, t), y: lerp(from.y, to.y, t) - Math.sin(t * Math.PI) * height };
}

export function frameAt(
  frames: readonly number[],
  fps: number,
  time: number,
  loop: boolean,
): number {
  const index = Math.floor(Math.max(0, time) * fps);
  return frames[loop ? index % frames.length : Math.min(index, frames.length - 1)] ?? 0;
}
